<template>
  <div id="app">
    <div v-if="login">
    <header>
      <div>
        <img src="./assets/logo.png" alt="Logo de pjo">
        <h1>Point Jazz Organisation</h1>
      </div>
    </header>
    <div class="navbar">
      <ul>
        <li><h2><router-link to="/groupes">Groupes <i class="fas fa-chevron-right"></i></router-link></h2></li>
        <li><h2><router-link to="/listes">Listes <i class="fas fa-chevron-right"></i></router-link></h2></li>
        <li><h2><router-link to="/genres">Genres <i class="fas fa-chevron-right"></i></router-link></h2></li>
        <li><h2><router-link v-if="store.getAdmin()" to="/users">Utilisateurs <i class="fas fa-chevron-right"></i></router-link></h2></li>
      </ul>
    </div><div class="vue">
      <router-view/>
    </div>
    </div>
    <router-view v-if="!login"/>
  </div>
</template>

<script>
import Store from './assets/Store'

export default {
  name: 'App',
  data () {
    return {
      login: false,
      store: ''
    }
  },
  methods: {
  },
  mounted () {
    this.store = new Store()
    if (this.store.getToken() === '') {
      this.login = false
      window.location.replace('/#/login')
    }
  }
}
</script>

<style lang="scss">
  @import url('https://fonts.googleapis.com/css?family=Roboto|Wendy+One&display=swap');
  * {
    margin: 0;
    padding: 0;
    font-family: 'Wendy One', sans-serif;
    p, li, select, label, legend, input {
      font-family: 'Roboto', sans-serif;
    }
  }
  header {
    width: calc(100% - 40px);
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 20px;
    background-color: #ba324f;
    a {
      color: #fff;
      background-color: #175676;
      text-decoration: none;
      padding: 10px;
      border-radius: 4px;
    }
    h1 {
      color: #fff;
    }
    div {
      display: flex;
      align-items: center;
    }
    img {
      width: 50px;
      margin-right: 10px;
    }
  }
  .navbar {
    height: calc(100vh - 70px);
    max-width: 250px;
    background-color: #175676;
    display: inline-block;
    a {
      display: flex;
      justify-content: space-between;
      color: #fff;
      text-decoration: none;
      padding: 10px 10px 10px 20px;
    }
    h2 a {
      background-color: #0E6998;
      padding: 10px;
    }
    .wrap {
      height: 0;
      overflow: hidden;
      transition: all linear .3s;
    }
  }
  .vue {
    display: inline-block;
    width: calc(100% - 178px - 40px);
    vertical-align: top;
    height: calc(100vh - 70px - 40px);
    padding: 20px;
    background-color: #f4f4f4;
    h2 {
      padding: 0 0 20px 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue